import { extendObservable } from 'mobx'
import get from 'lodash/get'

import { feeApi } from '@atheneum/api'

import Fee from '@models/Fee'

class FeeStore {
  constructor(staticData, modalStore, growlStore, ruleStore, projectStore) {
    extendObservable(this, {
      staticData,
      modalStore,
      growlStore,
      ruleStore,
      projectStore,
      epl: null,
      fee: null,
      feeRaw: null,
      etfTeams: {}
    })
  }

  get = async (id, untouched) => {
    const fee = await feeApi.getFee(id)
    await this.getTeamUnits(id)
    this.fee = new Fee(fee, this.staticData)
    this.epl = fee.expertProjectLink
    this.feeRaw = fee
    return untouched ? fee : this.fee
  }

  delete(id) {
    return feeApi.deleteFee(id).then(fee => {
      this.growlStore.addNotification({
        title: 'Success!',
        message: 'Fee deleted successfully.',
        type: 'success',
        autoClose: true
      })
    })
  }

  open(feeId) {
    return this.get(feeId).then(() => {
      this.showModal()
    })
  }

  showModal() {
    const shouldShowBackdatingForm = this.ruleStore.isDeliveryDateAffectedByBackdating(
      this.fee.deliveryDate
    )
    if (shouldShowBackdatingForm) {
      this.modalStore.show({
        type: 'BACKDATING_FEE_FORM',
        props: {
          fee: this.fee,
          project: this.projectStore.project,
          feeStore: this
        }
      })
    } else {
      this.modalStore.show({
        type: 'FEE_FORM',
        props: {
          fee: this.fee,
          type: 'FEE',
          project: this.projectStore.project,
          eplModel: this.eplModel,
          feeStore: this
        }
      })
    }
  }

  new() {
    this.fee = new Fee({}, this.staticData)
  }

  newFee() {
    this.fee = new Fee({ type: 'FEE', new: true }, this.staticData)
    this.showModal()
  }

  newCost() {
    this.fee = new Fee({ type: 'COST', new: true }, this.staticData)
    this.showModal()
  }

  newFeeCost(eplModel) {
    const epl = eplModel.epl
    const feeData = {}
    const { CONST } = this.staticData

    feeData.type = 'FEECOST'
    feeData.costTypeId = CONST.COST_TYPES.EXPERT_HONORARIUM
    feeData.deliverableType = CONST.DELIVERABLE_TYPES.ES_CONFERENCE_CALL
    feeData.deliveryDate = epl.dateInterviewed || epl.dateInterviewCanceled
    feeData.duration = epl.interviewDuration
    feeData.deliveredBy = epl.employees[0]?.id
    feeData.expert = { value: epl.expert.id, label: epl.expert.fullName }
    feeData.feeTypeId = this.calcFeeTypeId(epl.eplStatusId)
    feeData.eplId = epl.id
    feeData.eplStatusId = epl.eplStatusId
    feeData.credits = epl.credits || ''
    feeData.feeValue = epl.fee || ''
    feeData.feeCurrencyId = epl.feeCurrencyId || ''
    feeData.costValue = epl.free ? 0 : epl.honorarium
    feeData.costCurrencyId = epl.free ? 1 : epl.honorariumCurrencyId
    feeData.new = true

    return eplModel.getDetails().then(() => {
      feeData.employees = [
        { id: get(eplModel, 'details.employees[0].id', null) }
      ]
      this.eplModel = eplModel
      this.fee = new Fee(feeData, this.staticData)
      this.showModal()
    })
  }

  calcFeeTypeId(eplStatusId) {
    const { CONST } = this.staticData

    return eplStatusId === CONST.EPL_STATUSES.NOT_INTERVIEWED
      ? CONST.FEE_TYPES.CANCELATION_FEE
      : CONST.FEE_TYPES.BASE_FEE
  }

  getTeamUnits(id) {
    return feeApi.getTeamUnits(id).then(teamUnits => {
      teamUnits.forEach(tu => {
        this.etfTeams[tu.etfId] = tu
      })
    })
  }
}

export default FeeStore
